import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';

export const isAutomaticCheckOnboarding = (onboarding: EntityOnboarding) => {
  return onboarding.kind === 'adhoc_vendor_call' || onboarding.kind === 'continuous_monitoring_watchlist_check';
};

export const onboardingHasPlaybook = (onboarding: EntityOnboarding) => {
  return (
    onboarding.playbook &&
    onboarding.kind !== 'document' &&
    onboarding.kind !== 'adhoc_vendor_call' &&
    onboarding.kind !== 'continuous_monitoring_watchlist_check'
  );
};
